import * as ActionTypes from './ActionTypes';
import IAgreementProducts from './IAgreementProducts';
import AgreementProductsApi from './AgreementProductsApi';

function listSucceeded(result: IAgreementProducts[]) {
    return {
        type: ActionTypes.LIST_AGREEMENT_PRODUCTS_SUCCESS,
        result: result
    };
}

export function list(): (dispatch: (result: any) => void, getState: any) => any {
    return function (dispatch: (result: any) => void, getState: any) {
        return AgreementProductsApi.list().then((result: IAgreementProducts[]) => {
            dispatch(listSucceeded(result));
        });
    };
}
